import React, { useState } from 'react';
import PngExportModalContext from './PngExportModalContext';

type PngExportModalProviderProps = {
    children: React.ReactNode;
};

const PngExportModalProvider = ({
    children,
}: PngExportModalProviderProps): React.ReactElement => {
    const [showPngExport, setShowPngExport] = useState(false);

    return (
        <PngExportModalContext.Provider
            value={{
                showPngExport,
                setShowPngExport,
            }}
        >
            {children}
        </PngExportModalContext.Provider>
    );
};

export default PngExportModalProvider;
